import React from "react"
import { Tooltip } from "@mui/material"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { trans } from "@/_providers/Translation"

/**
 * Small "i" icon next to a chart heading that explains what the chart shows.
 * `name` is the key inside the `analytics.info` translation group.
 */
function ChartInfo({ name }) {
  return (
    <Tooltip
      title={trans(`analytics.info.${name}`)}
      arrow
      placement="top"
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: "12px",
            lineHeight: 1.5,
            maxWidth: 320,
            padding: "10px 12px",
          },
        },
      }}
    >
      <InfoOutlinedIcon className="chart-info-icon" />
    </Tooltip>
  )
}

export default ChartInfo
